import { render, staticRenderFns } from "./datos-perfil-inmo.vue?vue&type=template&id=fbfc20cc&scoped=true&lang=html&"
import script from "./datos-perfil-inmo.vue?vue&type=script&lang=js&"
export * from "./datos-perfil-inmo.vue?vue&type=script&lang=js&"
import style0 from "./datos-perfil-inmo.vue?vue&type=style&index=0&id=fbfc20cc&prod&lang=scss&scoped=true&"
import style1 from "./datos-perfil-inmo.vue?vue&type=style&index=1&id=fbfc20cc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbfc20cc",
  null
  
)

export default component.exports